import HS from './common'
import './status-page'

window.HS = HS

export default HS
